module.exports = __webpack_public_path__ + "static/exchange_add_calendar_1-bec92eb98aa5820616a4ccd600ca0604.png";